import { Box, Button, Stack } from "@mui/material";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Typography } from "new-components/typography/Typography";

import { ERROR_TYPE_TO_DATA } from "./constants";
import { ErrorType } from "./types";

interface ErrorViewProps {
  error: ErrorType;
}

export function ErrorView({ error }: ErrorViewProps) {
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();
  const { title, subtitle, description, redirect } = ERROR_TYPE_TO_DATA[error];

  return (
    <Stack
      id="error-view"
      height="100%"
      spacing="20px"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      paddingX={3}
    >
      <Typography
        variant="title"
        fontWeight="semibold"
        sx={{
          color: "#0D297D",
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="subtitle"
        fontWeight="semibold"
        sx={{
          color: "#0D297D",
        }}
      >
        {subtitle}
      </Typography>

      <Box
        sx={{
          maxWidth: "480px",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            color: "#000000BD",
          }}
        >
          {description}
        </Typography>
      </Box>

      {redirect && (
        <Button
          sx={{
            textTransform: "none",
            backgroundColor: "#006DD9",
            borderRadius: "29px",
            color: "white",
            px: "30px",
            py: "8px",

            "&:hover": {
              backgroundColor: "#0450BA",
            },
          }}
          onClick={() => {
            if ("link" in redirect) {
              navigate(redirect.link);
              return;
            }
            setSearchParams((params) => {
              Object.entries(redirect.addSearchParams).forEach(([key, value]) => params.set(key, value));
              return params;
            });
          }}
        >
          {redirect.title}
        </Button>
      )}
    </Stack>
  );
}
